mutation CreateScene($eventId: ID!, $overlayId: ID!, $name: String!) {
  scene: StreamToolsCreateScene(eventId: $eventId, overlayId: $overlayId, name: $name) {
    sceneId
    overlayId
    eventId
    name
    version
    createdAt
    elements {
      elementKind
      elementId
      x
      y
      z
      scale
      visible
      w
      h
    }
  }
}
